import React from 'react';
import { Badge } from '@/components/ui/badge';

const statusStyles = {
  // ── Shift statuses (finalised Feb 2026 colour system) ──
  OPEN:             'bg-blue-50 text-blue-700 border-blue-200',
  PARTIALLY_FILLED: 'bg-amber-50 text-amber-700 border-amber-200',
  ASSIGNED:         'bg-emerald-50 text-emerald-700 border-emerald-200',
  CONFIRMED:        'bg-emerald-50 text-emerald-700 border-emerald-200',
  IN_PROGRESS:      'bg-violet-50 text-violet-700 border-violet-200',
  COMPLETED:        'bg-slate-100 text-slate-700 border-slate-200',
  INVOICED:         'bg-teal-50 text-teal-700 border-teal-200',
  CANCELLED:        'bg-stone-100 text-stone-600 border-stone-200',
  NO_SHOW:          'bg-red-50 text-red-700 border-red-200',
  APPROVED:         'bg-emerald-50 text-emerald-700 border-emerald-200',
  // Timesheet statuses
  DRAFT: 'bg-gray-100 text-gray-600 border-gray-200',
  SUBMITTED: 'bg-amber-50 text-amber-700 border-amber-200',
  REJECTED: 'bg-red-50 text-red-700 border-red-200',
  // Invoice
  GENERATED: 'bg-teal-50 text-teal-700 border-teal-200',
  // Active / Inactive
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  inactive: 'bg-gray-100 text-gray-500 border-gray-200',
  // Compliance
  COMPLIANT: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  NON_COMPLIANT: 'bg-red-50 text-red-700 border-red-200',
  // Funding categories
  CORE: 'bg-blue-50 text-blue-700 border-blue-200',
  CAPACITY: 'bg-violet-50 text-violet-700 border-violet-200',
  CAPITAL: 'bg-orange-50 text-orange-700 border-orange-200',
  // Scope
  ALL: 'bg-gray-100 text-gray-600 border-gray-200',
  STATE: 'bg-sky-50 text-sky-700 border-sky-200',
  BRANCH: 'bg-teal-50 text-teal-700 border-teal-200',
  // Additional Day-4 statuses
  ACTIVE: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  ENDED: 'bg-gray-100 text-gray-500 border-gray-200',
  READY: 'bg-sky-50 text-sky-700 border-sky-200',
  PAID: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  PART_PAID: 'bg-amber-50 text-amber-700 border-amber-200',
  INCLUDED: 'bg-sky-50 text-sky-700 border-sky-200',
  NONE: 'bg-gray-100 text-gray-500 border-gray-200',
  HOURS: 'bg-blue-50 text-blue-700 border-blue-200',
  AMOUNT: 'bg-violet-50 text-violet-700 border-violet-200',
};

export function StatusBadge({ status, className = '' }) {
  if (!status) return null;
  const style = statusStyles[status] || 'bg-gray-100 text-gray-600 border-gray-200';
  return (
    <Badge
      variant="outline"
      className={`${style} text-xs font-medium px-2 py-0.5 whitespace-nowrap ${className}`}
      data-testid={`status-badge-${status}`}
    >
      {status.replace(/_/g, ' ')}
    </Badge>
  );
}
